// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.applicationAvailable--wrapper {
  background: #fff;
  padding: 0;
}
.applicationAvailable--headingWrapper {
  border-bottom: 1px solid #dde0e4;
  padding: 20px 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}
.applicationAvailable--headingWrapper .modal-heading {
  font-size: 22px;
  color: #1984bc;
  font-weight: 700;
  margin-bottom: 0;
}
.applicationAvailable--close {
  position: relative;
  display: inline-block;
  height: 30px;
  width: 30px;
  cursor: pointer;
}
.applicationAvailable--close:before,
.applicationAvailable--close:after {
  content: "";
  height: 30px;
  width: 2px;
  background: #505050;
  position: absolute;
  left: 13px;
  top: 0;
}
.applicationAvailable--close:before {
  transform: rotate(-45deg);
}
.applicationAvailable--close:after {
  transform: rotate(45deg);
}
.applicationAvailable--contentsWrapper {
  padding-bottom: 20px;
}
.applicationAvailable--separator {
  position: relative;
  margin-bottom: 40px;
}
.applicationAvailable--separator:after {
  position: absolute;
  left: 20px;
  right: 20px;
  width: calc(100% - 40px);
  border: 0.5px solid #dadde1;
  bottom: -30px;
  content: "";
}
.applicationAvailable--contentHeading {
  font-size: 17px;
  line-height: 1.5;
  font-weight: 700;
  color: #505050;
  padding-left: 30px;
  padding-right: 30px;
  padding: 10px 30px;
  margin-bottom: 5px;
}
.applicationAvailable--availableText,
.applicationAvailable--pipelineText {
  position: relative;
  padding-left: 20px;
}
.applicationAvailable--availableText:after,
.applicationAvailable--pipelineText:after {
  content: "";
  position: absolute;
  left: 0px;
  top: 5px;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: #000;
}
.applicationAvailable--availableText:after {
  background: #289cac;
}
.applicationAvailable--pipelineText:after {
  background: #f7b04f;
}
.applicationAvailable--table {
  padding-left: 17px;
  padding-right: 17px;
}
.applicationAvailable--tableHeader {
  display: flex;
  display: -webkit-flex;
  background: #f8f9fa;
  padding: 13px 15px;
  position: relative;
}
.applicationAvailable--tableHeading {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: #989eac;
  width: 33%;
}
.applicationAvailable--tableContentWrapper {
  max-height: 222px;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.applicationAvailable--tableRow {
  padding: 9px 0px 9px 15px;
  border-bottom: 1px solid #f8f9fa;
  display: flex;
  display: -webkit-flex;
}
.applicationAvailable--tableContent {
  font-size: 14px;
  color: #222222;
  line-height: 1.5;
  font-weight: 500;
  width: 33%;
}
.applicationAvailable--wrapper .breadCrumb__wrapper {
  padding: 10px 30px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/applicationsAvailable/applicationsAvailable.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,MAAM;AACR;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,2BAA2B;EAC3B,aAAa;EACb,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".applicationAvailable--wrapper {\n  background: #fff;\n  padding: 0;\n}\n.applicationAvailable--headingWrapper {\n  border-bottom: 1px solid #dde0e4;\n  padding: 20px 30px;\n  display: flex;\n  display: -webkit-flex;\n  justify-content: space-between;\n}\n.applicationAvailable--headingWrapper .modal-heading {\n  font-size: 22px;\n  color: #1984bc;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n.applicationAvailable--close {\n  position: relative;\n  display: inline-block;\n  height: 30px;\n  width: 30px;\n  cursor: pointer;\n}\n.applicationAvailable--close:before,\n.applicationAvailable--close:after {\n  content: \"\";\n  height: 30px;\n  width: 2px;\n  background: #505050;\n  position: absolute;\n  left: 13px;\n  top: 0;\n}\n.applicationAvailable--close:before {\n  transform: rotate(-45deg);\n}\n.applicationAvailable--close:after {\n  transform: rotate(45deg);\n}\n.applicationAvailable--contentsWrapper {\n  padding-bottom: 20px;\n}\n.applicationAvailable--separator {\n  position: relative;\n  margin-bottom: 40px;\n}\n.applicationAvailable--separator:after {\n  position: absolute;\n  left: 20px;\n  right: 20px;\n  width: calc(100% - 40px);\n  border: 0.5px solid #dadde1;\n  bottom: -30px;\n  content: \"\";\n}\n.applicationAvailable--contentHeading {\n  font-size: 17px;\n  line-height: 1.5;\n  font-weight: 700;\n  color: #505050;\n  padding-left: 30px;\n  padding-right: 30px;\n  padding: 10px 30px;\n  margin-bottom: 5px;\n}\n.applicationAvailable--availableText,\n.applicationAvailable--pipelineText {\n  position: relative;\n  padding-left: 20px;\n}\n.applicationAvailable--availableText:after,\n.applicationAvailable--pipelineText:after {\n  content: \"\";\n  position: absolute;\n  left: 0px;\n  top: 5px;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  background: #000;\n}\n.applicationAvailable--availableText:after {\n  background: #289cac;\n}\n.applicationAvailable--pipelineText:after {\n  background: #f7b04f;\n}\n.applicationAvailable--table {\n  padding-left: 17px;\n  padding-right: 17px;\n}\n.applicationAvailable--tableHeader {\n  display: flex;\n  display: -webkit-flex;\n  background: #f8f9fa;\n  padding: 13px 15px;\n  position: relative;\n}\n.applicationAvailable--tableHeading {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #989eac;\n  width: 33%;\n}\n.applicationAvailable--tableContentWrapper {\n  max-height: 222px;\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n}\n.applicationAvailable--tableRow {\n  padding: 9px 0px 9px 15px;\n  border-bottom: 1px solid #f8f9fa;\n  display: flex;\n  display: -webkit-flex;\n}\n.applicationAvailable--tableContent {\n  font-size: 14px;\n  color: #222222;\n  line-height: 1.5;\n  font-weight: 500;\n  width: 33%;\n}\n.applicationAvailable--wrapper .breadCrumb__wrapper {\n  padding: 10px 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
